(function () {
  'use strict';

  document.querySelectorAll('[data-yc-pdp]').forEach(initPdp);

  function initPdp(root) {
    var sectionId = root.getAttribute('data-section-id');
    var data = (window.ycProductData && window.ycProductData[sectionId]) || null;

    var form = root.querySelector('[data-yc-form]');
    var idInput = root.querySelector('[data-yc-variant-id]');
    var priceEl = root.querySelector('[data-yc-price]');
    var compareEl = root.querySelector('[data-yc-compare]');
    var addBtn = root.querySelector('[data-yc-addcart]');
    var addText = root.querySelector('[data-yc-addcart-text]');
    var stickyPrice = document.querySelector('[data-yc-sticky-price]');

    // ---------- variant selection ----------
    var selected = {};
    root.querySelectorAll('[data-yc-optgroup]').forEach(function (g) {
      var active = g.querySelector('.is-active');
      var idx = g.getAttribute('data-option-index');
      if (active) selected[idx] = active.getAttribute('data-value');
    });

    root.querySelectorAll('[data-yc-optbtn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        var group = btn.closest('[data-yc-optgroup]');
        group.querySelectorAll('[data-yc-optbtn]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[idx] = btn.getAttribute('data-value');
        var val = group.querySelector('[data-yc-optvalue]');
        if (val) val.textContent = btn.getAttribute('data-value');
        updateVariant();
      });
    });

    function currentSelection() {
      // ordered by option position 1..n
      var arr = [];
      Object.keys(selected).sort().forEach(function (k) { arr[Number(k) - 1] = selected[k]; });
      return arr;
    }

    var buyNow = root.querySelector('[data-yc-buynow]');

    function updateVariant() {
      if (!data) return;
      var sel = currentSelection();
      var match = data.variants.find(function (v) {
        return (v.option1 == null || v.option1 === sel[0]) &&
               (v.option2 == null || v.option2 === sel[1]) &&
               (v.option3 == null || v.option3 === sel[2]);
      });
      if (!match) {
        addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (buyNow) buyNow.hidden = true;
        return;
      }
      if (idInput) { idInput.value = match.id; idInput.removeAttribute('disabled'); }

      // price
      if (priceEl && data.prices[match.id]) priceEl.textContent = data.prices[match.id];
      if (stickyPrice && data.prices[match.id]) stickyPrice.textContent = data.prices[match.id];
      if (compareEl) {
        var c = data.compareAt[match.id];
        if (c) { compareEl.textContent = c; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }

      // availability
      if (match.available) {
        addBtn.disabled = false;
        if (addText) addText.textContent = 'Add to cart';
      } else {
        addBtn.disabled = true;
        if (addText) addText.textContent = 'Sold out';
      }
      if (buyNow) buyNow.hidden = !match.available;
      syncSticky();

      // switch gallery to this variant's image
      if (data.variantMedia && data.variantMedia[match.id]) {
        var vslide = root.querySelector('[data-yc-slide][data-media-id="' + data.variantMedia[match.id] + '"]');
        if (vslide) showImage(parseInt(vslide.getAttribute('data-index'), 10));
      }

      // update URL
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    // ---------- gallery slider: arrows + thumbs switch the active image ----------
    var thumbs = root.querySelectorAll('[data-yc-thumb]');
    var slides = root.querySelectorAll('[data-yc-slide]');
    var prevBtn = root.querySelector('[data-yc-prev]');
    var nextBtn = root.querySelector('[data-yc-next]');
    var counter = root.querySelector('[data-yc-gcount]');
    var viewport = root.querySelector('[data-yc-viewport]');
    var gi = 0;

    function showImage(n) {
      if (!slides.length) return;
      gi = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === gi); });
      thumbs.forEach(function (t, x) { t.classList.toggle('is-active', x === gi); });
      if (counter) counter.textContent = gi + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(gi - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(gi + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    if (viewport) {
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { showImage(gi - 1); }
        if (e.key === 'ArrowRight') { showImage(gi + 1); }
      });

      // touch swipe
      var sx = null;
      viewport.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) showImage(dx < 0 ? gi + 1 : gi - 1);
        sx = null;
      }, { passive: true });
    }

    // ---------- quantity ----------
    var qtyInput = root.querySelector('[data-yc-qty-input]');
    var minus = root.querySelector('[data-yc-qty-minus]');
    var plus = root.querySelector('[data-yc-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    // ---------- sticky mobile bar ----------
    var sticky = document.querySelector('[data-yc-sticky]');
    var stickyAdd = document.querySelector('[data-yc-sticky-add]');
    var buyBlock = root.querySelector('.yc-pdp__buy');
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.hidden = e.isIntersecting;
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      obs.observe(buyBlock);
    }
    function syncSticky() {
      if (stickyAdd && addBtn) {
        stickyAdd.disabled = addBtn.disabled;
        var s = stickyAdd.querySelector('span');
        if (s && addText) s.textContent = addText.textContent;
      }
    }
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    // ---------- AJAX add to cart (Dawn cart integration) ----------
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var errEl = root.querySelector('[data-yc-form-error]');

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

        var fd = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }

        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              showError(res.description || res.message || 'Could not add to cart.');
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              if (typeof cart.setActiveElement === 'function' && document.activeElement) {
                cart.setActiveElement(document.activeElement);
              }
              if (cart.classList) cart.classList.remove('is-empty');
              cart.renderContents(res);
              if (typeof cart.open === 'function') cart.open();
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
            publishCartUpdate();
          })
          .catch(function () { showError('Could not add to cart. Try again.'); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    function showError(msg) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    }

    function publishCartUpdate() {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yc-product' });
        }
      } catch (e) { /* noop */ }
    }
  }

  // ---- size guide: dialog open/close + in/cm toggle ----
  var sizeDlg = document.querySelector('[data-yc-sizeguide]');
  if (sizeDlg && typeof sizeDlg.showModal === 'function') {
    document.querySelectorAll('[data-yc-sizeguide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { sizeDlg.showModal(); });
    });
    sizeDlg.querySelector('[data-yc-sizeguide-close]').addEventListener('click', function () { sizeDlg.close(); });
    // click on backdrop closes
    sizeDlg.addEventListener('click', function (e) { if (e.target === sizeDlg) sizeDlg.close(); });
  }

  document.querySelectorAll('[data-yc-sizechart]').forEach(function (chart) {
    chart.querySelectorAll('[data-yc-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-yc-unit');
        // keep every chart on the page (dialog + accordion) in sync
        document.querySelectorAll('[data-yc-sizechart]').forEach(function (c) {
          c.setAttribute('data-unit', unit);
          c.querySelectorAll('[data-yc-unit]').forEach(function (b) {
            var on = b.getAttribute('data-yc-unit') === unit;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      });
    });
  });

})();
